// Vars //
var $body = jQuery('body');

function backToTop() {
    var body = jQuery("body");
    jQuery(window).scroll(function () {
        var scroll = jQuery(window).scrollTop();

        if (scroll >= 100) {
            body.addClass("show-scroll-to-top");
        } else {
            body.removeClass("show-scroll-to-top");
        }
    });
}

function menuScroll() {
    var body = jQuery("body");
    jQuery(window).scroll(function () {
        var scroll = jQuery(window).scrollTop();

        if (scroll >= 100) {
            body.addClass("fixed-navigation");
        } else {
            body.removeClass("fixed-navigation");
        }
    });
}

// Header Slider - Setup Function
function sliderSetup() {
    jQuery('.slider-container.slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.slider-container');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = false,
            infinite = false
        ;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        $slider.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Product Slider
 * Used for multiple blocks - Feature Product Slider, Feature Category Product Slider
 * 
 */
function featureProductSliderSetup() {
    jQuery('.feature-product-slider-container .slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.feature-product-slider-container');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = false,
            infinite = false,
            slidesToShow, slidesToScroll;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        if (jQuery(window).width() > 1600) {
            slidesToShow = 4;
            slidesToScroll = 1;
        } else if (jQuery(window).width() > 1200) {
            slidesToShow = 3;
            slidesToScroll = 1;
        } else if (jQuery(window).width() > 767) {
            slidesToShow = 2;
            slidesToScroll = 1;
            centerMode = true;
        } else if (jQuery(window).width() < 480) {
            slidesToShow = 1;
            slidesToScroll = 1;
            centerMode = true;
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Content Block Slider
 * 
 */
function contentBlockSliderSetup() {
    jQuery('.slider-content-block.slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.slider-content-block');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = false,
            infinite = false
            ;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        $slider.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Logo Slider Block - sc-logo-slider-block.twig
 * 
 */
function logoSliderBlockSetup() {
    jQuery('.logo-slider-container .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.logo-slider-container');
    
    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = false,
            infinite = true,
            slidesToShow = 1,
            slidesToScroll = 1;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        if (jQuery(window).width() > 1600) {
            slidesToShow = 6;
        } else if (jQuery(window).width() > 1400) {
            slidesToShow = 4;
        } else if (jQuery(window).width() > 1200) {
            slidesToShow = 3;
        } else if (jQuery(window).width() > 767) {
            slidesToShow = 2;
            centerMode = true;
        } else if (jQuery(window).width() < 480) {
            slidesToShow = 1;
            centerMode = true;
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            autoplay: true,
            autoplaySpeed: 3000,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>'
        });
    });
}


/**
 * 
 * Content Slider Block
 * 
 */
function gbContentSlider() {
    jQuery('.gb-content-slider.slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.gb-content-slider');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = true,
            infinite = true
        ;

        $slider.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            autoplay: true,
            autoplaySpeed: 4000,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>'
        });
    });
}

/**
 * Feature Home Slider Block
 */
function gbFeatureHomeSliderBlock() {
    jQuery('.gb-feature-home-slider .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.gb-feature-home-slider');
    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = false,
            infinite = true,
            variableWidth = true,
            slidesToShow = 1,
            slidesToScroll = 1;

        if (jQuery(window).width() > 1400) {
            slidesToShow = 4;
        } else if (jQuery(window).width() > 1200) {
            slidesToShow = 3;
        } else if (jQuery(window).width() > 767) {
            slidesToShow = 2;
            centerMode = true;
        } else if (jQuery(window).width() < 480) {
            slidesToShow = 1;
            centerMode = true;
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            variableWidth: variableWidth,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>'
        });
    });
}

/**
 * Property Gallery Block
 */
function propertyGallerySlider() {
    jQuery('.property-gallery-slider .slick-initialized').slick('unslick');
    
    var $sliderContainer = jQuery('.property-gallery-slider');
    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = false,
            infinite = true,
            variableWidth = true,
            centerMode = true,
            slidesToShow = 1,
            slidesToScroll = 1;

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            variableWidth: variableWidth,
            centerMode: centerMode,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>'
        });
    });
}

/**
 * Related Posts Slider
 */
function relatedPostsSlider() {
    jQuery('.related-articles .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.related-articles');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = true,
            infinite = true,
            slidesToShow = 2, slidesToScroll = 1;

        if (jQuery(window).width() > 1200) {
            slidesToShow = 2;
            slidesToScroll = 1;
        } else if (jQuery(window).width() < 480) {
            slidesToShow = 1;
            slidesToScroll = 1;
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>'
        });
    });
}

/**
 * Testimonial Slider
 */
 function testimonialSlider() {
    jQuery('.testimonial-slider .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.testimonial-slider');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = true,
            infinite = true,
            slidesToShow = 1, slidesToScroll = 1;

        if (jQuery(window).width() > 1200) {
            slidesToShow = 3;
            centerMode = true;
        } 
        else if (jQuery(window).width() > 767) {
            slidesToShow = 2;
        } 
        else if (jQuery(window).width() <= 480) {
            slidesToShow = 1;
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>'
        });
    });
}

/**
 * Related Post Slider
 */
 function relatedPostSlider() {
    jQuery('.related-post-block-slider .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.related-post-block-slider');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = true,
            infinite = true,
            slidesToShow = 1, slidesToScroll = 1;

        if (jQuery(window).width() > 1200) {
            slidesToShow = 3;
            centerMode = true;
            infinite = false;
        } 
        else if (jQuery(window).width() > 767) {
            slidesToShow = 2;
        } 
        else if (jQuery(window).width() <= 480) {
            slidesToShow = 1;
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="far fa-arrow-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="far fa-arrow-right"></i></span></a>'
        });
    });
}


function testimonialMasonaryGrid() {
    var body = jQuery("body");

    if(body.hasClass('post-type-archive-sc_testimonials')) {
        // Masonary Grid
        var macy = Macy({
            container: '.post-listing--testimonial',
            trueOrder: false,
            waitForImages: false,
            margin: {
                x: 20,
                y: 20 
            },
            columns: 2,
            breakAt: {
                1200: 2,
                940: 2,
                520: 1,
                400: 1
            }
        });
    }
}